import {
  ExistingFile,
  NewOrExistingFile,
} from "@coworker/apprestructured/src/shared/types/newOrExistingFile";
import { Image } from "../types/images";
import { CreateUpload } from "@coworker/apprestructured/src/task-management/types/Upload";

const LEGACY_IMAGE_FOLDER = "tasks/resized/1024w";

export const imageToExistingFile = (image: Image): NewOrExistingFile => {
  return {
    type: "existing",
    rotation: image.rotation,
    file: {
      id: image.id ?? "",
      url: image.url,
      name: image.fileName,
      size: 1,
    },
  };
};

export const uploadToImage = (
  upload: CreateUpload,
  mediaId: string,
  index: number,
  rotation: number
): Image => {
  return {
    mediaId,
    fileName: upload.bucket_id,
    rotation: rotation,
    orderIndex: index,
    folder: LEGACY_IMAGE_FOLDER,
    url: "Not set", // Dummy url. Upon fetch the url will be filled by the backend.
  };
};

export const existingFileToImage = (
  file: ExistingFile,
  mediaId: string,
  index: number
): Image => {
  return {
    id: file.file.id!,
    mediaId,
    fileName: file.file.name,
    rotation: file.rotation,
    orderIndex: index,
    folder: LEGACY_IMAGE_FOLDER,
    url: "Not set", // Dummy url. Upon fetch the url will be filled by the backend.
  };
};
